import { useState, useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/all', label: '分类' },
    { to: '/about', label: '关于我们' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <span className="text-2xl font-bold text-primary-500" style={{ fontFamily: 'var(--font-heading)' }}>
              基德漫画
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 cursor-pointer ${
                  location.pathname === link.to ||
                  (link.to.startsWith('/category') && location.pathname.startsWith('/category'))
                    ? 'text-primary-500'
                    : 'text-foreground-700 hover:text-foreground-950'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/category/all"
              className="inline-flex items-center gap-1.5 px-4 py-2 bg-primary-500 text-background-50 text-sm font-medium rounded-full whitespace-nowrap hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
            >
              <i className="ri-search-line text-base"></i>
              开始阅读
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-950 cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium px-3 py-2 rounded-lg whitespace-nowrap transition-colors cursor-pointer ${
                  location.pathname === link.to ||
                  (link.to.startsWith('/category') && location.pathname.startsWith('/category'))
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/category/all"
              className="inline-flex items-center justify-center gap-1.5 px-4 py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-full whitespace-nowrap hover:bg-primary-600 transition-colors duration-200 cursor-pointer mt-2"
            >
              <i className="ri-search-line text-base"></i>
              开始阅读
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}